import React from 'react'
import PropTypes from 'prop-types'
import { Document, Page } from 'react-pdf'

import '../../stylesheet/pdfviewer.css'

class ConsumerPdfViewer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            numPages: null,
            pageNo: 1
        }
    }

    loadFile = ({ numPages }) => {
        this.setState({ numPages })
    }

    nextPage = () => {
        const { numPages, pageNo } = this.state
        if (numPages > pageNo) {
            this.setState({ pageNo: pageNo + 1 })
        }
    }

    prevPage = () => {
        if (this.state.pageNo > 1) {
            this.setState({ pageNo: this.state.pageNo - 1 })
        }
    }

    render() {
        const { numPages, pageNo } = this.state
        
        

        return (
            <div className="pdf-container">
                <div className="doc-controls">
                    <small>{this.props.name && `File: ${this.props.name}`}</small>
                 
                    <div>
                        <button
                            className="doc-control-button btn btn-sm btn-std"
                            onClick={this.prevPage}>
                            Prev page
                        </button>
                    </div>
                    <div>
                        <button
                            className="doc-control-button btn btn-sm btn-std"
                            onClick={this.nextPage}>
                            Next page
                        </button>
                    </div>

                    <small>{numPages && `Page ${pageNo} of ${numPages}`}</small>

                </div>
                <Document
                    file={`data:application/pdf;base64,${this.props.file}`}
                    onLoadSuccess={this.loadFile}
                   >
                    <Page pageNumber={pageNo} 
                     
                    //  width={500}
                     />
                </Document>
                 {/* <small>{this.props.name && `File: ${this.props.name}`}</small>
                 <PDFReader url={`data:application/pdf;base64,${this.props.file}`} page={pageNo} showAllPage={true}  /> */}
            </div>
        )
    }
}

ConsumerPdfViewer.propTypes = {
    file: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
}

ConsumerPdfViewer.defaultProps = {
    file: '',
    name: ''
}

export default ConsumerPdfViewer


// WEBPACK FOOTER //
// ./src/components/register/kycdocumentviewer.jsx